module.exports = __webpack_public_path__ + "img/sales promotion.dd3c81b2.svg";